<template>
  <KeywordsMiniHeader
    v-model="inputValue"
    @focus="searchFocus = true"
    :is-show="showMiniHeader"
  />
  <KeywordsHeader
    v-model="inputValue"
    @focus="searchFocus = true"
    :hidden="showMiniHeader"
    :can-input="false"
  />
  <H5SearchFoucs
    v-if="searchFocus"
    @back="searchFocus = false"
  />
</template>

<script setup>
import KeywordsHeader from '@/components/H5/KeywordsHeader/index.vue'
import KeywordsMiniHeader from '@/components/H5/KeywordsMiniHeader/index.vue'
import H5SearchFoucs from '@/components/H5/H5SearchFoucs/index.vue'
import { useEventListener } from '@vueuse/core'

const route = useRoute()

const searchFocus = ref(false)
const showMiniHeader = ref(false)

const inputValue = ref(route.query.keyword)

useEventListener(window, 'scroll', (e) => {
  const scrollTop = e.target.scrollingElement.scrollTop
  if (scrollTop > 120) {
    showMiniHeader.value = true
  } else {
    showMiniHeader.value = false
  }
})
</script>

<style lang="less" scoped>

</style>
